const FORMSVIEW = {
  nameAcivity: "Nome/Atividade",
  type: "Cara",
  group: "Conjunto",
  state: "Doença",
  totalQuestion: "Todas as perguntas",
  actions: "Ações",

  versions: "Versões",
  finish: "Finalizado",
  formType: "Tipo de formulário",
  subForms: "Subformulários",
  multiForms: "MultiFormulários",
  createdDate: "Data de criação",
  updatedDate: "Data de atualização",
  currentState: "Estado atual",
  uniqueId: "ID de formulário exclusivo",

  copyForm: "Copiar formulário...",
  lockForm: "Forma de bloco",

  tittleEdit: "Editar formulário",
  messageEdit: `Este formulário tem <strong>{version}</strong> versão(ões).`,
  messageEdit2: `Por favor, selecione uma versão da lista, para prosseguir para a sua edição.`,
  version: "Versão:",
  accept: "Aceitar",
  cancel: "Cancelar",

  copyToForm: "Copie o formulário",
  EnterNameToForm: "Digite um nome para o novo formulário:",
  copy: "Cópia de",
  selectGorup: "Selecione o grupo:",

  tittleLockForm: `Fechar formulário: {activity}`,
  msgLockForm: "Esta ação não pode ser desfeita, você tem certeza?",

  tittleDeleteForm: "Excluir formulário: {activity}",
  msgDeleteForm: "Esta opção não pode ser desfeita, tem certeza de que deseja excluir o formulário?",

  notifyClosedForm: {
    tittle: "Fechar formulários",
    textSuccess: "O formulário foi fechado com sucesso",
    textError: `Ocorreu um erro ao fechar o formulário({message})`
  },

  notifyCopyForm: {
    tittleGroup: "Lista de Grupos",
    msgGroup: "Ocorreu um erro ao consultar a lista de Grupos {message}",
    tittleCopyForm: "Copiar formulários",
    msgErrorCopy: "Ocorreu um erro ao consultar as informações do formulário",
    msgSuccessCopy: "Cópia do formulário bem-sucedida",
    msgErrorCopyForm: `Ocorreu um erro ao copiar o formulário({message})`
  },

  notifyDeleteForm: {
    title: "Excluir formulários",
    success: "O formulário foi excluído com sucesso",
    error: "Ocorreu um erro ao excluir o formulário"
  },

  notifyEditForm: {
    tittlemulti: "[MultiForms] Ação não permitida",
    msgMulti: "Não há versões associadas ao MultiForms. Selecione um tipo de formulário diferente.",
    tittle: "Editar formulários",
    msg: "Ocurrio un error, al consultar la informacion del formulario"
  },

  dropdownMenu: {
    update: "Atualizar",
    all: "Tudo",
    actives: "Ativo",
    deletes: "Eliminado"
  }
};

export default { FORMSVIEW };
